const state = {
    projectId: '',
    projectName: ''
};
const mutations = {
    setProjectId: (state:any, id:string) => {
        state.projectId = id;
    },
    setProjectName: (state:any, name:string) => {
        state.projectName = name;
    }
};

export default {
    namespaced: true, // 这个是命名空间，用来区分不同的模块，我是根据文件的名字来区分
    state,
    mutations
};
